getFedoraKeys = ->
  $("#fedora-keys").data()

getFedoraData = ->
  $("#fedora-data").data()

window.getFedoraKeys = getFedoraKeys
window.getFedoraData = getFedoraData
